import { render } from "./DigitalLabels.vue?vue&type=template&id=09c797dd&scoped=true"
import script from "./DigitalLabels.vue?vue&type=script&lang=js"
export * from "./DigitalLabels.vue?vue&type=script&lang=js"

import "./DigitalLabels.vue?vue&type=style&index=0&id=09c797dd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c797dd"]])

export default __exports__